import Nullstack from 'nullstack';
export default function IconTypographyOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-typography-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 20h3"
  }), "   ", Nullstack.element("path", {
    d: "M14 20h6"
  }), "   ", Nullstack.element("path", {
    d: "M6.9 15h6.9"
  }), "   ", Nullstack.element("path", {
    d: "M13 13l3 7"
  }), "   ", Nullstack.element("path", {
    d: "M5 20l4.09 -10.906"
  }), "   ", Nullstack.element("path", {
    d: "M10.181 6.183l.819 -2.183h2l3.904 8.924"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}